__turbopack_context__.v({
  "new-field-button": "EmailSignatureEditorNewFieldButton-module-scss-module__8hZjAq__new-field-button",
  "new-field-button-subtitle": "EmailSignatureEditorNewFieldButton-module-scss-module__8hZjAq__new-field-button-subtitle",
});
